var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useRef, useState } from "react";
import { Tooltip } from "@mui/material";
import useWindowWidthDebounced from "./useWindowWidth";
var OverFlowTooltip = function (_a) {
    var children = _a.children, _b = _a.placement, placement = _b === void 0 ? "bottom-start" : _b, title = _a.title, _c = _a.className, className = _c === void 0 ? "w-full max-w-full cellMaxWidth" : _c, _d = _a.tooltipWidth, tooltipWidth = _d === void 0 ? "300px" : _d, rest = __rest(_a, ["children", "placement", "title", "className", "tooltipWidth"]);
    var contentRef = useRef(null);
    var _e = useState(false), isOverflowed = _e[0], setIsOverflowed = _e[1];
    var width = useWindowWidthDebounced();
    useEffect(function () {
        if (contentRef.current) {
            var el = contentRef.current;
            setIsOverflowed(el.scrollWidth > el.clientWidth);
        }
    }, [children, width]);
    var cellContent = (_jsx("div", __assign({ ref: contentRef, className: "truncate ".concat(className) }, rest, { children: children })));
    return (_jsx(_Fragment, { children: isOverflowed ? (_jsx(Tooltip, { title: title !== null && title !== void 0 ? title : children, placement: placement, componentsProps: {
                tooltip: {
                    sx: {
                        maxWidth: tooltipWidth, //tooltip width
                    },
                },
            }, children: cellContent })) : (cellContent) }));
};
export default OverFlowTooltip;
